namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmStrukturaVlastnosti extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmStrukturaVlastnostiObj & GContent;
        returnValue: boolean;
        openModal: boolean;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmStrukturaVlastnostiObj());
            this.detailObj.createBase({
                contentName: "detailAdmStrukturaVlastnosti",
                contentCaption: "jres:29802692",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.returnValue = this.returnValue;
            this.detailObj.openModal = this.openModal;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.createAdmStrukturaVlastnostiObsahSubTask())
                tabs.push(this.detailObj.createNadrizeneSubTask());
                tabs.push(this.detailObj.createAdmStrukturaVlastnostiVazbySubTask())
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.createAdmStrukturaVlastnostiObsahGroup());
                groups.push(this.detailObj.createNadrizeneGroup());
                groups.push(this.detailObj.createAdmStrukturaVlastnostiVazbyGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmStrukturaVlastnosti", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            var rowPovinnost = this.findFormRows("row_priz_pov");
            rowPovinnost.gformrow("setLabel", "jres:29925144", "jres:33000605") //RC 33000605 : V�echny vlastnosti struktury budou povinn�, pokud bude samostatn� p�id�na na dokument.
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmStrukturaVlastnostiObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiReadDto> {
        private gridVazby: JQuery<HTMLElement>;
        private gridNadrizene: JQuery<HTMLElement>;
        returnValue: boolean;
        openModal: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_stv) ? this.data.ixs_stv.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmStrukturaVlastnosti.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsstv");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        returnValueFunction() {
            if (this.data) {
                if (this.data.ixs_stv)
                    return { ixs_stv: this.data.ixs_stv };
            } 
            return null;
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.returnValue = this.returnValue;
            filterObj.openModal = this.openModal;
            if (this.openModal == true)
                $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", filterObj],
                    dataObj, {
                    height: 800,
                    width: 800
                });
            else 
                $.content().navigate(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmStrukturaVlastnosti.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            if (this.openModal == true) {
                return [
                    "actEdit*",
                    { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                    { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                    { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
                ]
            } else {
                return [
                    "actEdit*",
                    { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                    "actCancelEdit*",
                    {
                        type: "static", caption: "jres:33000138", icon: "fa-link", favorite: true, children: [
                            { action: this.cnt.actions.actOpenSeznamAdmStrukturaNavazanyObjekt },
                            { action: this.cnt.actions.actOpenSeznamAdmVlastnostTypDokumentu }
                        ]
                    },
                    { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                    { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
                ]
            }
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamAdmStrukturaNavazanyObjekt: {
                    icon: "fa-link",
                    caption: "jres:33000415", 
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmStrukturaNavazanyObjekt()
                    }
                },
                actOpenSeznamAdmVlastnostTypDokumentu: {
                    icon: "fa-link",
                    caption: "jres:33000477", //RC 33000477 : Nav�zan� typy dokument�
                    tooltip: "jres:33000511", //RC 33000511 : Umo�n� p�i�adit strukturu vlastnost� jako p�eddefinovan� k vybran�m typ�m dokument�
                    enabled: !this.options.newRecord,
                    run: () => {
                        this.openSeznamAdmVlastnostTypDokumentu()
                    }
                },
                actOpenDetailVlastnostStruktura: {
                    caption: "jres:32131033", //RC 33000561 : Detail strutury nebo vlastnosti
                    tooltip: "jres:33000562", //RC 33000562 : Otev�e detail struktury nebo vlastnosti 
                    icon: "gi-detail",
                    run: (ev, ctx) => {
                        this.openDetailVlastnostProfil();
                    }
                },
                actOpenDetailProfil: {
                    icon: "gi-detail",
                    caption: "jres:33000564", //RC 33000564 : Detail p�i�azen� struktury a porfilu
                    run: () => {
                        this.openDetailProfil();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_stv");
            this.MakeField("nazev" );
            this.MakeField("zkratka");
            this.MakeField("kod", {
                flag: this.createFlagNemenne(),
                validators: [
                    new Gordic.Validators.Required({ stopping: true }),
                    new Gordic.Validators.Length({ min: 0, max: 6 }),
                    this.createValidatorKod()
                ]
            });
            this.MakeBoolField("priz_pov");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
        }

        private createValidatorKod(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000480".format("_"), //RC 33000480 : Zadan� �et�zec obsahuje nepovolen� znaky.
                validate: (value, source) => {
                    if (value) {
                        if (value.toString().includes("_"))
                            return false;
                        if (value.toString() == "0")
                            return false;
                        return true;
                    }
                    return false;
                }
            });
        }

        createAdmStrukturaVlastnostiObsahSubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-struktura-vlastnosti-obsah",
                    title: "jres:33000459",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-struktura-vlastnosti-obsah" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmStrukturaVlastnostiObsah",
                    serverParams: {
                        Id: "SeznamAdmStrukturaVlastnostiObsah",
                        ixs_stv: this.data.ixs_stv,
                        tabOpen: true
                    }
                }
            }
        }

        createAdmStrukturaVlastnostiVazbySubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-adm-struktury-vazby",
                    title: "jres:33000558", //RC 33000558 : Vazby profilu
                    opened: true,
                    locked: true,
                    group: { id: "_tab-adm-struktury-vazby" },
                    menuBar: this.cnt.actions.createBar(["actOpenDetailVlastnostStruktura*"]),
                    open: () => {
                        this.getVazbyStruktury();
                    }
                },
                init: (tab) => {
                    this.createGridVazby(tab);
                }
            }
        }

        createNadrizeneSubTask(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-nadrizene",
                    title: "jres:33000565", //RC 33000565 : Nad��zen� profily
                    opened: true,
                    locked: true,
                    group: { id: "_tab-nadrizene" },
                    open: () => {
                        this.getNadrizene();
                    }
                },
                init: (tab) => {
                    this.createGridNadrizene(tab);
                }
            }
        }

        createNadrizeneGroup(): IGTabGroupOptions {
            return { id: "_tab-nadrizene", caption: "jres:33000565" }
        }

        createAdmStrukturaVlastnostiObsahGroup(): IGTabGroupOptions {
            return { id: "_tab-struktura-vlastnosti-obsah", caption: "jres:33000459" }
        }

        createAdmStrukturaVlastnostiVazbyGroup(): IGTabGroupOptions {
            return { id: "_tab-adm-struktury-vazby", caption: "jres:33000558" }
        }

        private openSeznamAdmStrukturaNavazanyObjekt() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                Id: "SeznamAdmVlastnostTypObjektu",
                typ_vps: 10,
                ixs: this.data.ixs_stv
            })
        }

        private openSeznamAdmVlastnostTypDokumentu() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypDokumentu"], {
                Id: "SeznamAdmVlastnostTypDokumentu",
                typ_vps: 10,
                ixs: this.data.ixs_stv
            })
        }

        private openDetailVlastnostProfil() {
            var activeRow = this.gridVazby.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.typ == 20) {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmVlastnost", {}],
                        {
                            ID: "DetailAdmVlastnost",
                            newRecord: false,
                            ixs_vla: activeRow.ixs
                        }
                    )
                } else {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnosti", {}],
                        {
                            ID: "DetailAdmStrukturaVlastnosti",
                            newRecord: false,
                            ixs_stv: activeRow.ixs
                        }
                    )
                }
            }
        }

        private createGridVazby(tab: JQuery<HTMLElement>) {
            this.gridVazby = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.createGridFormatVazby(),
                defaultAction: this.cnt.actions.actOpenDetailVlastnostStruktura,
                selection: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailVlastnostStruktura?.update({ enabled: ctx.count == 1 })
                }
            })
        }

        private createGridFormatVazby(): Gordic.Data.GridFormat {
            return new Gordic.Data.GridFormat()
                .addStructureColumn({
                    name: "ixs_txt",
                    caption: "jres:32131029",
                })
                .addIconColumn({
                    name: "aktivita",
                    caption: "jres:33000559", //RC 33000559 : Aktivita vazby
                    iconTemplate: (row) => {
                        return Gordic.Adm.WebControls.GAdmGridFunctions.createAktivitaCaptionIcon(row.aktivita);
                    }
                })
                .addTextColumn({
                    name: "typ",
                    caption: "jres:33000553",
                    cellTemplate: (row) => {
                        if (row.typ == 20)
                            return "jres:29932128";
                        else if (row.typ == 10)
                            return "jres:29931622";
                        else
                            return "jres:33000410"
                    }
                })
                .addNumberColumn({
                    name: "poradi",
                    caption: "jres:30029253"
                })
        }

        private getVazbyStruktury() {
            if (this.gridVazby != undefined && this.gridVazby != null) {
                if (this.data.ixs_stv) {
                    this.cnt.isl.AdmStrukturaVlastnosti.listVazby({ ixs_stv: this.data.ixs_stv }).getData().done((obj) => {
                        let treeProcessor = new Gordic.Data.Tree(Gordic.Data.Tree.parentIdOrganizer("ixs_nad"), { defaultState: "open" })
                        var view = new Gordic.Data.View(obj, {
                            key: "ixs",
                            processors: { tree: treeProcessor }
                        })
                        this.gridVazby.ggrid("setData", view);
                    })
                }
            }
        }

        private getNadrizene() {
            if (this.gridNadrizene != undefined && this.gridNadrizene != null) {
                if (this.data.ixs_stv) {
                    this.cnt.isl.AdmStrukturaVlastnosti.listNadrizene({ ixs_stv: this.data.ixs_stv }).getData().done((obj) => {
                        this.gridNadrizene.ggrid("setData", obj);
                    })
                }
            }
        }

        private createGridNadrizene(tab: JQuery<HTMLElement>) {
            this.gridNadrizene = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: this.createGridFormatNadrizene(),
                defaultAction: this.cnt.actions.actOpenDetailProfil,
                selection: (ev, ctx) => {
                    this.cnt.actions.actOpenDetailProfil?.update({ enabled: ctx.count == 1 })
                }
            })
        }

        private createGridFormatNadrizene() {
            return new Gordic.Data.GridFormat()
                .addIconColumn({
                    name: "aktivita",
                    caption: "jres:33000559", //RC 33000559 : Aktivita vazby
                    iconTemplate: (row) => {
                        return Gordic.Adm.WebControls.GAdmGridFunctions.createAktivitaCaptionIcon(row.aktivita);
                    }
                })
                .addTextColumn({
                    name: "typ",
                    caption: "jres:33000553",
                    cellTemplate: (row) => {
                        if (row.typ == 20)
                            return "jres:29932128";
                        else if (row.typ == 10)
                            return "jres:29931622";
                        else
                            return "jres:33000410"
                    }
                })
                .addTextColumn({
                    name: "ixs_txt",
                    caption: "jres:32131029",
                })
        }

        private openDetailProfil() {
            var activeRow = this.gridNadrizene.ggrid("activeRow");
            if (activeRow) {
                if (activeRow.typ == 0) {
                    $.content().navigate(
                        ["Gordic.Adm.WebControls.DetailAdmProfilVlastnosti", {}],
                        {
                            ID: "DetailAdmProfilVlastnosti",
                            newRecord: false,
                            ixs_pro: activeRow.ixs
                        }
                    )
                }
            }
        }

    }
}